import { render, staticRenderFns } from "./Zaehler.vue?vue&type=template&id=ef6d55d6"
import script from "./Zaehler.vue?vue&type=script&lang=js"
export * from "./Zaehler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports